/**
 * ReceitaDeleteDialog Component
 */

import { useState } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { receitasAdapter } from "@/data";
import { useToast } from "@/hooks/use-toast";
import type { ReceitaCompleta } from "@/types/receita";

interface ReceitaDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  receita: ReceitaCompleta | null;
  onSuccess: () => void;
}

export function ReceitaDeleteDialog({
  open,
  onOpenChange,
  receita,
  onSuccess,
}: ReceitaDeleteDialogProps) {
  const [isDeleting, setIsDeleting] = useState(false);
  const { toast } = useToast();

  const handleDelete = async () => {
    if (!receita) return;

    try {
      setIsDeleting(true);
      await receitasAdapter.delete(receita.receita.id_receita);
      onSuccess();
    } catch (error) {
      console.error("Erro ao excluir receita:", error);
      toast({
        title: "Erro",
        description: "Não foi possível excluir a receita.",
        variant: "destructive",
      });
    } finally {
      setIsDeleting(false);
    }
  };

  if (!receita) return null;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Confirmar Exclusão</AlertDialogTitle>
          <AlertDialogDescription>
            Tem certeza que deseja excluir a receita <strong>{receita.receita.nome}</strong>?
            Esta ação não pode ser desfeita e todos os ingredientes associados também serão removidos.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleDelete}
            disabled={isDeleting}
            className="bg-destructive hover:bg-destructive/90"
          >
            {isDeleting ? "Excluindo..." : "Excluir"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
